// extracted by mini-css-extract-plugin
export default {"feed":"styles-module__feed__src-labstep-web-components-ExperimentWorkflow-LinkedList-_c7M8y"};